import { Typography, Grid, Avatar, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { ApplicantInfo } from '../../shared/VolunteerApplicationServiceTypes';
import defaultAvatar from '../../assets/images/defaultAvatar.svg';
import { useEffect, useState } from 'react';
import { checkImage } from '../../shared/Utils';

const { Text } = Typography;
const { useBreakpoint } = Grid;

interface LandingPageProps {
	applicantInfo?: ApplicantInfo;
}

export const ApplicantDetailsTable = ({ applicantInfo }: LandingPageProps) => {
	const { t } = useTranslation();
	const screens = useBreakpoint();
	const isMobile = !screens.sm;
	const profileImage = applicantInfo?.photoUrl || '';
	const [validImage, setValidImage] = useState(profileImage);
	useEffect(() => {
		const fetchImage = async () => {
			const checkImageValue = await checkImage(profileImage);
			if (profileImage && checkImageValue) {
				setValidImage(profileImage);
			} else {
				setValidImage(defaultAvatar);
			}
		};

		void fetchImage();
	}, [profileImage]);

	return (
		<>
			<div
				className={`p-8 pt-6 rounded-lg border-solid border border-gray-200 ${
					isMobile ? 'bg-gray-200' : 'bg-white'
				}`}
			>
				<div className="w-full text-center mb-4">
					<Text className="font-sans font-semibold text-base text-center text-secondary-black">
						{t('candidateDetails')}
					</Text>
				</div>
				{!isMobile && (
					<Divider className="mt-0 border-solid border border-gray-200" />
				)}
				<div
					className={`flex ${
						!isMobile ? 'flex-row' : 'flex-col items-center'
					} items-start gap-6`}
				>
					<div
						className={`flex flex-col items-center ${!isMobile ? 'px-4' : ''}`}
					>
						<Avatar
							src={validImage}
							size={!isMobile ? 100 : 80}
							shape="circle"
							alt="Profile"
						/>
					</div>

					<div
						className={`grid ${
							!isMobile ? 'grid-cols-4 px-4' : 'grid-cols-2'
						} gap-4 w-full `}
					>
						{[
							{
								label: t('firstName'),
								value: applicantInfo?.firstName || 'N/A',
							},
							{ label: t('lastName'), value: applicantInfo?.lastName || 'N/A' },
							{ label: t('age'), value: applicantInfo?.age },
							{ label: t('idCardNo'), value: applicantInfo?.srcmid },
							{
								label: t('gender'),
								value: applicantInfo?.gender
									? applicantInfo.gender.charAt(0).toUpperCase() +
									  applicantInfo.gender.slice(1).toLowerCase()
									: '',
							},
							{
								label: t('mobile'),
								value: applicantInfo?.mobile,
							},
							{
								label: t('email'),
								value: applicantInfo?.email,
							},
						].map((item) => (
							<div key={item.label} className="flex flex-col">
								<Text className="text-sm">{item.label}</Text>{' '}
								<Text
									className={`text-gray-650 text-sm mt-2 font-bold ${
										item.label === t('email') ? 'whitespace-nowrap' : ''
									}`}
								>
									{item.value || '-'}
								</Text>{' '}
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
};
